export default function onScreen($document, $window) {
  'ngInject';

  return function postLink($scope, $element, $attrs) {
    const element = $element[0];

    function check() {
      const rect = element.getBoundingClientRect();
      const viewportHeight =
        $window.innerHeight ||
        Math.max($document[0].documentElement.clientHeight, $document[0].body.clientHeight);
      if (rect.top <= viewportHeight) {
        $scope.$evalAsync(() => {
          $scope.$eval($attrs.onScreen);

          if ($attrs.onScreenRemoveWhenDone) {
            $document.off('scroll', check);
          }
        });
      }
    }

    $scope.$evalAsync(check);

    $document.on('scroll', check);
    $scope.$on('$destroy', () => {
      $document.off('scroll', check);
    });
  };
}
